import { OrderItem } from "@/interfaces/domain/Order";
import { Product } from "@/interfaces/domain/Product";

export const formatToCurrency = (number: number | string) => {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(+number);
};

export const formatWeight = (weight: number) => {
  if (weight < 1) {
    return parseFloat(String(weight * 1000)).toFixed(0) + "g";
  }
  return parseFloat(String(weight)).toFixed(2).padEnd(3, "0").replace(".", ",") + "kg";
};

export const adjustCaseText = (text: string) => {
  if (!text) return "";
  const alphabet = "a b c d e f g h i j k l m n o p q r s t u v w x y z";
  const textArray = text.split(" ");
  let i = 0;
  const newString: string[] = [];
  while (i !== textArray.length) {
    let upperLetter = "";
    const letter = textArray[i].split("", 1);
    if (alphabet.includes(letter[0])) {
      upperLetter = letter[0].toUpperCase();
    } else if (letter[0] !== undefined) {
      upperLetter = letter[0];
    }
    newString[i] = upperLetter + textArray[i].slice(1).toLowerCase() + " ";
    i++;
  }
  return newString.join(" ");
};

export const formatProductToOrderItem = (product: Product): OrderItem => {
  const price = product.preco.preco_encarte
    ? product.preco.preco_encarte
    : product.preco.preco_original;
  return {
    item: product,
    peso: product.peso,
    qualidade: null,
    instrucao: "",
    quantidade: 0,
    preco_unitario: price,
    preco_total: 0,
  };
};

export const checkIfProductIsHorti = (productCategoryName: string) => {
  if (!productCategoryName) return false;
  return (
    productCategoryName.includes("Frutas") ||
    productCategoryName.includes("Legumes") ||
    productCategoryName.includes("Verduras") ||
    productCategoryName.includes("Hortaliças") ||
    productCategoryName.includes("Folhagens")
  );
};
